"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    CalendarLookups: Symbol("CalendarLookups"),
    CalendarACLClient: Symbol("CalendarACLClient"),
    CalendarACLRoute: Symbol("CalendarACLRoute"),
    CalendarEventRsvpAttendeeBatchClient: Symbol("CalendarEventRsvpAttendeeBatchClient"),
    CalendarEventRsvpAttendeeBatchRoute: Symbol("CalendarEventRsvpAttendeeBatchRoute"),
    CalendarEventRsvpAttendeeClient: Symbol("CalendarEventRsvpAttendeeClient"),
    CalendarEventRsvpAttendeeRoute: Symbol("CalendarEventRsvpAttendeeRoute"),
    CalendarRsvpAttendeeBatchClient: Symbol("CalendarRsvpAttendeeBatchClient"),
    CalendarRsvpAttendeeBatchRoute: Symbol("CalendarRsvpAttendeeBatchRoute"),
    CalendarRsvpAttendeeClient: Symbol("CalendarRsvpAttendeeClient"),
    CalendarRsvpAttendeeRoute: Symbol("CalendarRsvpAttendeeRoute"),
    CalendarEventsClient: Symbol("CalendarEventsClient"),
    CalendarEventsRoute: Symbol("CalendarEventsRoute"),
    CalendarBatchClient: Symbol("CalendarBatchClient"),
    CalendarBatchRoute: Symbol("CalendarBatchRoute"),
    CalendarClient: Symbol("CalendarClient"),
    CalendarRoute: Symbol("CalendarRoute"),
    CalendarRsvpBatchClient: Symbol("CalendarRsvpBatchClient"),
    CalendarRsvpBatchRoute: Symbol("CalendarRsvpBatchRoute"),
    CalendarRsvpClient: Symbol("CalendarRsvpClient"),
    CalendarRsvpRoute: Symbol("CalendarRsvpRoute"),
    CalendarEventBatchClient: Symbol("CalendarEventBatchClient"),
    CalendarEventBatchRoute: Symbol("CalendarEventBatchRoute"),
    CalendarEventClient: Symbol("CalendarEventClient"),
    CalendarEventRoute: Symbol("CalendarEventRoute"),
    CalendarEventRsvpBatchClient: Symbol("CalendarEventRsvpBatchClient"),
    CalendarEventRsvpBatchRoute: Symbol("CalendarEventRsvpBatchRoute"),
    CalendarEventRsvpClient: Symbol("CalendarEventRsvpClient"),
    CalendarEventRsvpRoute: Symbol("CalendarEventRsvpRoute"),
    CalendarEventRsvpInvitationTypeBatchClient: Symbol("CalendarEventRsvpInvitationTypeBatchClient"),
    CalendarEventRsvpInvitationTypeBatchRoute: Symbol("CalendarEventRsvpInvitationTypeBatchRoute"),
    CalendarEventRsvpInvitationTypeClient: Symbol("CalendarEventRsvpInvitationTypeClient"),
    CalendarEventRsvpInvitationTypeRoute: Symbol("CalendarEventRsvpInvitationTypeRoute"),
    CalendarEventRsvpAttendeeStatusBatchClient: Symbol("CalendarEventRsvpAttendeeStatusBatchClient"),
    CalendarEventRsvpAttendeeStatusBatchRoute: Symbol("CalendarEventRsvpAttendeeStatusBatchRoute"),
    CalendarEventRsvpAttendeeStatusClient: Symbol("CalendarEventRsvpAttendeeStatusClient"),
    CalendarEventRsvpAttendeeStatusRoute: Symbol("CalendarEventRsvpAttendeeStatusRoute"),
    CalendarEventStatusBatchClient: Symbol("CalendarEventStatusBatchClient"),
    CalendarEventStatusBatchRoute: Symbol("CalendarEventStatusBatchRoute"),
    CalendarEventStatusClient: Symbol("CalendarEventStatusClient"),
    CalendarEventStatusRoute: Symbol("CalendarEventStatusRoute"),
    CalendarEventTypeBatchClient: Symbol("CalendarEventTypeBatchClient"),
    CalendarEventTypeBatchRoute: Symbol("CalendarEventTypeBatchRoute"),
    CalendarEventTypeClient: Symbol("CalendarEventTypeClient"),
    CalendarEventTypeRoute: Symbol("CalendarEventTypeRoute"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.CalendarLookups).to(_1.CalendarLookups);
    bind(TYPES.CalendarACLRoute).to(_1.CalendarACLRoute);
    bind(TYPES.CalendarACLClient).to(_1.CalendarACLClient);
    bind(TYPES.CalendarEventRsvpAttendeeBatchClient).to(_1.CalendarEventRsvpAttendeeBatchClient);
    bind(TYPES.CalendarEventRsvpAttendeeBatchRoute).to(_1.CalendarEventRsvpAttendeeBatchRoute);
    bind(TYPES.CalendarEventRsvpAttendeeClient).to(_1.CalendarEventRsvpAttendeeClient);
    bind(TYPES.CalendarEventRsvpAttendeeRoute).to(_1.CalendarEventRsvpAttendeeRoute);
    bind(TYPES.CalendarRsvpAttendeeBatchClient).to(_1.CalendarRsvpAttendeeBatchClient);
    bind(TYPES.CalendarRsvpAttendeeBatchRoute).to(_1.CalendarRsvpAttendeeBatchRoute);
    bind(TYPES.CalendarRsvpAttendeeClient).to(_1.CalendarRsvpAttendeeClient);
    bind(TYPES.CalendarRsvpAttendeeRoute).to(_1.CalendarRsvpAttendeeRoute);
    bind(TYPES.CalendarEventsClient).to(_1.CalendarEventsClient);
    bind(TYPES.CalendarEventsRoute).to(_1.CalendarEventsRoute);
    bind(TYPES.CalendarBatchClient).to(_1.CalendarBatchClient);
    bind(TYPES.CalendarBatchRoute).to(_1.CalendarBatchRoute);
    bind(TYPES.CalendarClient).to(_1.CalendarClient);
    bind(TYPES.CalendarRoute).to(_1.CalendarRoute);
    bind(TYPES.CalendarRsvpBatchClient).to(_1.CalendarRsvpBatchClient);
    bind(TYPES.CalendarRsvpBatchRoute).to(_1.CalendarRsvpBatchRoute);
    bind(TYPES.CalendarRsvpClient).to(_1.CalendarRsvpClient);
    bind(TYPES.CalendarRsvpRoute).to(_1.CalendarRsvpRoute);
    bind(TYPES.CalendarEventBatchRoute).to(_1.CalendarEventBatchRoute);
    bind(TYPES.CalendarEventBatchClient).to(_1.CalendarEventBatchClient);
    bind(TYPES.CalendarEventRoute).to(_1.CalendarEventRoute);
    bind(TYPES.CalendarEventClient).to(_1.CalendarEventClient);
    bind(TYPES.CalendarEventRsvpAttendeeStatusBatchClient).to(_1.CalendarEventRsvpAttendeeStatusBatchClient);
    bind(TYPES.CalendarEventRsvpAttendeeStatusBatchRoute).to(_1.CalendarEventRsvpAttendeeStatusBatchRoute);
    bind(TYPES.CalendarEventRsvpAttendeeStatusClient).to(_1.CalendarEventRsvpAttendeeStatusClient);
    bind(TYPES.CalendarEventRsvpAttendeeStatusRoute).to(_1.CalendarEventRsvpAttendeeStatusRoute);
    bind(TYPES.CalendarEventRsvpBatchClient).to(_1.CalendarEventRsvpBatchClient);
    bind(TYPES.CalendarEventRsvpBatchRoute).to(_1.CalendarEventRsvpBatchRoute);
    bind(TYPES.CalendarEventRsvpClient).to(_1.CalendarEventRsvpClient);
    bind(TYPES.CalendarEventRsvpRoute).to(_1.CalendarEventRsvpRoute);
    bind(TYPES.CalendarEventRsvpInvitationTypeBatchClient).to(_1.CalendarEventRsvpInvitationTypeBatchClient);
    bind(TYPES.CalendarEventRsvpInvitationTypeBatchRoute).to(_1.CalendarEventRsvpInvitationTypeBatchRoute);
    bind(TYPES.CalendarEventRsvpInvitationTypeClient).to(_1.CalendarEventRsvpInvitationTypeClient);
    bind(TYPES.CalendarEventRsvpInvitationTypeRoute).to(_1.CalendarEventRsvpInvitationTypeRoute);
    bind(TYPES.CalendarEventStatusBatchClient).to(_1.CalendarEventStatusBatchClient);
    bind(TYPES.CalendarEventStatusBatchRoute).to(_1.CalendarEventStatusBatchRoute);
    bind(TYPES.CalendarEventStatusClient).to(_1.CalendarEventStatusClient);
    bind(TYPES.CalendarEventStatusRoute).to(_1.CalendarEventStatusRoute);
    bind(TYPES.CalendarEventTypeBatchClient).to(_1.CalendarEventTypeBatchClient);
    bind(TYPES.CalendarEventTypeBatchRoute).to(_1.CalendarEventTypeBatchRoute);
    bind(TYPES.CalendarEventTypeClient).to(_1.CalendarEventTypeClient);
    bind(TYPES.CalendarEventTypeRoute).to(_1.CalendarEventTypeRoute);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
